<template>
<div id="newsletter-attachment">
  <h2>{{ title }} Attachment #{{ attachment.id }}</h2>

  <h3>Attachment Details</h3>

  <div>
    <p>Name: {{ attachment.name || "No available name" }}</p>

    <p>Description: {{ attachment.description || "No available description" }}</p>

    <p>Filename: {{ attachment.filename }}</p>

    <p>Mimetype: {{ attachment.mimetype }}</p>

    <p>Bytesize: {{ attachment.byte_size }}</p>

    <p>Visible? {{ attachment.visible }}</p>

    <p>Newsletter Service ID: {{ attachment.external_id || "No Newsletter Service ID" }}</p>

    <p>Created at: {{ attachment.created_at }}</p>

    <p>Updated at: {{ attachment.updated_at }}</p>
  </div>

  <nav>
    <ul>
      <li>
        <email-attachment-download
          button="true"
          :emailId="emailId"
          :attachmentId="attachmentId"
          :emailType="emailType"
        ></email-attachment-download>
      </li>
    </ul>
  </nav>
</div>
</template>

<script>
import EmailAttachmentDownload from '@/components/EmailAttachmentDownload'

import EmailMixin from '@/mixins/EmailMixin'

import { mapState } from 'vuex'

export default {
  props: {
    attachmentId: {
      type: [ Number, String ],
      default: undefined,
      required: true
    }
  },

  computed: mapState({
    attachment: state => state.EmailModule.attachment
  }),

  components: {
    'email-attachment-download': EmailAttachmentDownload
  },

  mixins: [
    EmailMixin
  ],

  created () {
    this.get()
  },

  methods: {
    get () {
      this.$store.dispatch(
        `EmailModule/getAttachment`,
        {
          attachmentId: this.attachmentId,
          emailType: this.emailType,
          emailId: this.emailId
        }
      ).catch(this.$root.processErrors)
    }
  }

}
</script>



// WEBPACK FOOTER //
// src/components/EmailAttachment.vue